// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3PF0Z","subheader":"ReorderModal_subheader__VxNED","listWrap":"ReorderModal_listWrap__rGrrk"};